import { useNavigate } from 'react-router-dom'

export function PortalBackButton() {
  const navigate = useNavigate()

  return (
    <button
      onClick={() => navigate('/')}
      className="fixed top-4 left-4 z-[100] flex items-center gap-2 px-3 py-2 rounded-lg
                 bg-[var(--color-bg)]/60 text-[var(--color-text-secondary)] text-sm font-sans
                 backdrop-blur-sm border border-[var(--color-border)]/50
                 opacity-50 hover:opacity-100 hover:bg-[var(--color-bg)]/90
                 hover:text-[var(--color-text)] hover:border-[var(--color-border)]
                 transition-all duration-200 cursor-pointer"
    >
      <span>&larr;</span>
      <span>RTGS Lab Portal</span>
    </button>
  )
}
